import type { FeatureGroup } from '../../../types';
import { CRM_INTEGRATIONS_FEATURE_GROUP } from '../group';

export const TICKET_SCANNERS_FEATURE_GROUP: FeatureGroup = {
  guid: '282960a2-1cf9-4757-972a-94f2aa0fff00',
  name: 'ticket-scanners',
  description: 'Ticket Scanners app — scan and validate Altru-issued tickets at the gate',
  product: 'app',
  parentGuid: CRM_INTEGRATIONS_FEATURE_GROUP.guid,
};
